/**
 * Revision-related types
 * Re-exports from auto-generated API types with additional app-specific types
 */
import type { components } from '../magpiie-client/api-types';

// Re-export API types for convenience
export type Revision = components['schemas']['GetRevisionDto'];
export type Draft = components['schemas']['DraftDto'];
export type RevisionFolder = components['schemas']['RevisionFolderDto'];
export type Asset = components['schemas']['FileDto'];
export type PaginatedRevisions =
  components['schemas']['PaginatedListRevisionDto'];
export type PaginatedRevisionFolders =
  components['schemas']['PaginatedListRevisionFolderDto'];
export type CreateRevisionDto = components['schemas']['CreateRevisionDto'];
export type CreateDraftDto = components['schemas']['CreateDraftDto'];
export type CreateRevisionFolderDto =
  components['schemas']['CreateRevisionFolderDto'];
export type UpdateRevisionFolderDto =
  components['schemas']['UpdateRevisionFolderDto'];

// Content type enum
export enum ContentType {
  VIDEOS = 'VIDEOS',
  SHORTS = 'SHORTS',
  AUDIO = 'AUDIO',
  IMAGES = 'IMAGES',
  DOCUMENTS = 'DOCUMENTS',
}

// Upload callbacks
export interface RevisionUploadCallbacks {
  onSuccess?: (assetId: number) => void | Promise<void>;
  onError?: (error: Error) => void;
  onProgress?: (progress: number) => void;
}

// Folder operation callbacks
export interface FolderOperationCallbacks {
  onAdd: (folder: RevisionFolder, type: ContentType) => void;
  onEdit: (id: number, name: string, type: ContentType) => void;
  onRemove: (id: number, type: ContentType) => void;
}

// Optimistic update revert callbacks
export interface OptimisticReverts {
  revertAdd: (tempId: number, type: ContentType) => void;
  revertEdit: (id: number, oldName: string, type: ContentType) => void;
  revertDelete: (folder: RevisionFolder, type: ContentType) => void;
}

// Pagination state
export interface PaginationState {
  page: number;
  hasMore: boolean;
  isLoading: boolean;
}

// Draft status enum lives in `constants/draftStatus.ts` — re-exported here
// so existing call sites (`import { DraftStatus } from 'types/revisions'`)
// keep compiling.
export { DraftStatus } from '../constants/draftStatus';

export interface DraftAssigneeDto {
  id: number;
  first_name: string;
  last_name?: string | null;
  full_name: string;
  email: string;
  profile_image?: string | null;
}
